import React from "react";
import { Link } from "react-router-dom";
import {Facebook, Twitter, Linkedin, Instagram, Mail} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Company: [
      { name: "About Osrey", path: "/about" },
      { name: "Blog", path: "/blog" },
      { name: "Resources", path: "/resources" },
      { name: "Contact", path: "/contact" },
    ],
    Resources: [
      { name: "Knowledge Hub", path: "/resources" },
      { name: "Osrey Guide", path: "/blog/osrey-complete-guide" },
      { name: "FAQ", path: "/resources#faq" },
      { name: "Glossary", path: "/resources#glossary" },
    ],
    Legal: [
      { name: "Privacy Policy", path: "#" },
      { name: "Terms of Service", path: "#" },
      { name: "Cookie Policy", path: "#" },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: "#", label: "Facebook" },
    { icon: Twitter, href: "#", label: "Twitter" },
    { icon: Linkedin, href: "#", label: "LinkedIn" },
    { icon: Instagram, href: "#", label: "Instagram" },
  ];

  return (
    <footer className="bg-[#1C2A35] border-t border-[#3A4E5F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="text-3xl font-bold bg-gradient-to-r from-[#00D4AA] to-[#FF6B35] bg-clip-text text-transparent">
                Osrey
              </span>
            </Link>
            <p className="text-[#F5F7FA] text-sm mb-4 max-w-sm">
              Everything Osrey, Curated and Connected. Discover the world of Osrey and Osreys through our comprehensive guides, articles, and community resources.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="p-2 bg-[#0A0D12] rounded-lg hover:bg-[#3A4E5F] transition-colors duration-300 group"
                >
                  <social.icon className="w-5 h-5 text-[#F5F7FA] group-hover:text-[#00D4AA] transition-colors duration-300" />
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-[#F5F7FA] font-semibold mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-[#F5F7FA]/70 text-sm hover:text-[#00D4AA] transition-colors duration-300"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Copyright */}
        <div className="border-t border-[#3A4E5F] pt-8 text-center">
          <p className="text-[#F5F7FA]/60 text-sm">
            © {currentYear} Osrey. All rights reserved. Built with passion for the Osrey community.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;